import { render, staticRenderFns } from "./learn.vue?vue&type=template&id=56ea5c1c&scoped=true"
import script from "./learn.vue?vue&type=script&lang=js"
export * from "./learn.vue?vue&type=script&lang=js"
import style0 from "./learn.vue?vue&type=style&index=0&id=56ea5c1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea5c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ea5c1c')) {
      api.createRecord('56ea5c1c', component.options)
    } else {
      api.reload('56ea5c1c', component.options)
    }
    module.hot.accept("./learn.vue?vue&type=template&id=56ea5c1c&scoped=true", function () {
      api.rerender('56ea5c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/courses/learn.vue"
export default component.exports